import { exhaustiveCheck } from '@/utils/exhaustive-check';
import { ComponentProps } from 'react';
import { ReturnData } from '../../utils/get-return-data';
import { ReturnsChart } from './returns-chart';
import { ReturnCardVariant } from './returns-drawer-content';

const MAX_VISIBLE_PERIODS = 6;

type ReturnsChartWrapperProps = {
  variant: Exclude<ReturnCardVariant, 'ALL_TIME'>;
  returnData: ReturnData;
};

export const ReturnsChartWrapper = ({ variant, returnData }: ReturnsChartWrapperProps) => {
  const returnsChartConfig = getReturnsChartConfig({ variant, returnData });

  return <ReturnsChart returnsChartConfig={returnsChartConfig} />;
};

const getReturnsChartConfig = ({ variant, returnData }: ComponentProps<typeof ReturnsChartWrapper>) => {
  if (!returnData.hasValuations) {
    return {
      variant: 'EMPTY_STATE_NO_KIID' as const,
      monthlyReturns: returnData.monthlyReturns.slice(0, MAX_VISIBLE_PERIODS),
    };
  }

  switch (variant) {
    case 'MONTH':
      return {
        variant: 'MONTH' as const,
        monthlyReturns: returnData.monthlyReturns.slice(0, MAX_VISIBLE_PERIODS),
        currency: returnData.currency,
      };
    case 'YEAR':
      return {
        variant: 'YEAR' as const,
        yearlyReturns: returnData.yearlyReturns.slice(0, MAX_VISIBLE_PERIODS),
        currency: returnData.currency,
      };
    default:
      return exhaustiveCheck(variant);
  }
};
